import { EventEmitter } from '@angular/core';
import { ELearningDashboardClass } from '../Elearning-Models';
import { IAPIService } from './API-Service/IAPIService';

export abstract class IClassService{
    abstract GetClassesForTeacher(): void;
    abstract classesAvailableEmitter: EventEmitter<ELearningDashboardClass[]>;
    abstract UpdateDashboardVisibility(dashboardClass: ELearningDashboardClass, 
        visibility: boolean):void;
    abstract GetClassesForAdminFromTeacherID(teacherID: number): void;
    abstract GetOrSetClasses(teacherID?: number): void;
}

export class ClassService implements IClassService{
    classesAvailableEmitter: EventEmitter<ELearningDashboardClass[]> = new EventEmitter<ELearningDashboardClass[]>();
    classesAvailable: ELearningDashboardClass[];

    constructor(private APIService: IAPIService){
    }
    
    GetClassesForAdminFromTeacherID(teacherID: number): void {
       let fName = "GetClassesForAdminTeacherID";
        this.APIService
        .GetClassesForAdminFromTeacherID(teacherID)
        .subscribe(data=>{
            this.onClassesForTeacherDataAvailable(data);
        });
    }

    GetClassesForTeacher(){
        let fName = "GetClassesForTeacher";        
        this.APIService
        .GetClassesForTeacher()
        .subscribe(data=>{
            this.onClassesForTeacherDataAvailable(data);
        });
    }

    GetOrSetClasses(teacherID: number = null){
        if(teacherID == null){
            // Then I am already a teacher and should only be getting my classes
            if(!this.classesAvailable){
                this.GetClassesForTeacher();
            }
            else{
                this.onClassesForTeacherDataAvailable(this.classesAvailable);
            }
        }
        else{
            // I am an admin and am searching for teachers
            this.GetClassesForAdminFromTeacherID(teacherID);
        }
    }

    onClassesForTeacherDataAvailable(data: ELearningDashboardClass[]) {
        this.classesAvailable = data;
        this.classesAvailableEmitter.emit(this.classesAvailable);
    }

    UpdateDashboardVisibility(dashboardClass: ELearningDashboardClass, visibility: boolean){
        let fName = "UpdateDashboardVisibility";
        this.APIService
        .UpdateDashboardVisibility(dashboardClass.ID, visibility)
        .subscribe(result => {
            if(result){
                this.classesAvailable.find(ca => ca.ID == dashboardClass.ID).Hidden = visibility;
                this.classesAvailableEmitter.emit(this.classesAvailable);                
            }
            else{
                //notify                
                throw("Failed to update visibility");
            }
        });
    }
}

